// extracted by mini-css-extract-plugin
export var badge = "_ih-2";
export var detailsPanel = "_ih-0";
export var resultRow = "_ih-1";